import React, { useEffect } from "react";
import AttributeTable from "./Table";
import Header from "@commons/header";
import Tab from "@components/tabs";
import { useSelector } from "react-redux";
import { Module } from "@apis/index";
import { RootState } from "@store/index";

const AttributeList = () => {
  const { data: modules } = useSelector((state: RootState) => state.modules);

  useEffect(() => {
    Module.list({ state: "modules", params: { isActive: true } });
  }, []);

  const items = modules.map((module) => ({
    label: module.name,
    component: AttributeTable,
    props: { moduleId: module.id },
  }));
  return (
    <>
      <Header title="All Attributes" />
      <Tab items={items} fitContent paramKey="module" />
    </>
  );
};

export default AttributeList;
